export default __webpack_public_path__ + "static/media/need_add_project.1feed80c.png";